import React from 'react'
import styled from '@emotion/styled'
import {
  isSameRaceMulti,
  isTippingTicket,
} from '@core/Areas/AccountActivity/Components/Ticket/helpers'
import { sortSameRaceMultiTicketLegs } from '@core/Areas/AccountActivity/helpers'
import type { BetLoopShareTicket } from '@core/Areas/BetLoop/types'
import type { Ticket } from '@core/Areas/AccountActivity/types'
import { LegStatusSilks } from './Components/LegStatusSilks'
import { meetingIdToContestType } from '@core/Areas/Racing/helpers'
import { SelectionStatusSilks } from './Components/SelectionStatusSilks'
import { shouldHideLegStatusSilks } from './helpers/shouldDisplayLegsStatusSilks'

export const StatusSilks: React.FC<{ ticket: Ticket | BetLoopShareTicket }> = ({ ticket }) => {
  if (shouldHideLegStatusSilks(ticket)) return null

  let legs = ticket.legs
  if (isSameRaceMulti(ticket)) {
    legs = sortSameRaceMultiTicketLegs(ticket)
  }

  const isMulti = !isTippingTicket(ticket) && ticket.legs.length > 1

  return (
    <StatusSilksContainerStyled>
      {isMulti ? (
        <LegStatusSilks legs={legs} planSeq={ticket.planSeq} />
      ) : (
        <SelectionStatusSilks
          selections={legs[0].selections}
          contestType={meetingIdToContestType(legs[0].fixtureId)}
        />
      )}
    </StatusSilksContainerStyled>
  )
}

// ======
// Styles
// ======

const StatusSilksContainerStyled = styled.div({
  display: 'flex',
  alignItems: 'center',
  gap: '0.2rem',
  flexDirection: 'row',
  justifyContent: 'flex-end',

  '& > div': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '2rem',
  },
})
